<form [formGroup]="form">
  <textarea
    class="textarea-v2"
    [class.error-border]="!!errorMessage"
    trim
    autocomplete="off"
    formControlName="control"
    [placeholder]="placeholder"
    [attr.readOnly]="readonly ? 'readonly' : null"
  ></textarea>

  @if (errorMessage) {
    <span class="form-control-error-msg d-flex mt-2">{{ errorMessage }}</span>
  }
</form>
